import { render, staticRenderFns } from "./SMListTemplate.vue?vue&type=template&id=5c2381b4"
import script from "./SMListTemplate.vue?vue&type=script&lang=js"
export * from "./SMListTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports